import { render, staticRenderFns } from "./Follow.vue?vue&type=template&id=7a345e96"
import script from "./Follow.vue?vue&type=script&lang=ts"
export * from "./Follow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports